
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import SidebarItem from './SidebarItem.vue'
import variables from '@/styles/_variables.scss'
import Cookies from 'js-cookie'

@Component({
  name: 'SideBar',
  components: {
    SidebarItem
  }
})
export default class extends Vue {
  get name() {
    return (UserModule.userInfo as any).name
      ? (UserModule.userInfo as any).name
      : JSON.parse(Cookies.get('user_info') as any).name
  }

  get defOpen() {
    let path = ['/']
    this.routes.forEach((n: any) => {
      if (n.meta && n.meta.roles && n.meta.roles[0] === this.roles[0]) {
        path.splice(0, 1, n.path)
      }
    })
    return path
  }

  get defAct() {
    return this.$route.path
  }

  get sidebar() {
    return AppModule.sidebar
  }

  get storeId() {
    return UserModule.storeId || ''
  }

  get roles() {
    return UserModule.roles
  }

  get routes() {
    // 依赖 storeId / permissions，进入商户或权限变化后重新计算菜单
    const _sid = this.storeId
    const _perms = UserModule.permissions
    void _perms
    const routes = JSON.parse(
      JSON.stringify([...(this.$router as any).options.routes])
    )
    let menuList: any[] = []
    const menu = routes.find((item: any) => item.path === '/')
    if (menu) {
      menuList = menu.children || []
    }
    // 操作日志 / 派送记录等均按 meta.permission（权限表）控制侧栏显示
    const hasPerm = (route: any) => {
      const code = route.meta && route.meta.permission
      if (!code) return true
      return UserModule.hasPermission(code)
    }
    const hasStore = !!_sid
    if (!hasStore) {
      return menuList.filter(
        (route: any) =>
          (!route.meta || !route.meta.requiresStore) &&
          (!route.meta || !route.meta.hidden) &&
          hasPerm(route)
      )
    }
    return menuList.filter(
      (route: any) => (!route.meta || !route.meta.hidden) && hasPerm(route)
    )
  }

  get variables() {
    return variables
  }

  get isCollapse() {
    return !this.sidebar.opened
  }

  private async logout() {
    this.$store.dispatch('LogOut').then(() => {
      this.$router.replace({ path: '/login' })
    })
  }
}
